import { render } from "./viewAlertDetailsPopup.vue?vue&type=template&id=48e33672&scoped=true"
import script from "./viewAlertDetailsPopup.js?vue&type=script&lang=js"
export * from "./viewAlertDetailsPopup.js?vue&type=script&lang=js"

import "./viewAlertDetailsPopup.vue?vue&type=style&index=0&id=48e33672&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e33672"]])

export default __exports__